<template>
  <v-container>
    <sub-navigation-obchody></sub-navigation-obchody>
    <v-layout row wrap>
      <v-flex xs12 :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
        <!-- <h1 class="h2 mb-30">Nadřízení pracovníci</h1> -->
        <!-- <v-layout row wrap class="shop-layout mb-20">
          <v-flex xs12 class="mb-2 ml-4">
            <strong>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></strong>
          </v-flex>
          <v-flex xs12 sm4 class="px-3 pb-2">
            <v-text-field
              label="Hledáte něco konkrétního?"
              autocomplete
              solo
              hide-details
              append-icon="search"
              v-model="search"
            ></v-text-field>
          </v-flex>
        </v-layout> -->
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :search="search"
          hide-actionss
        >
          <template v-slot:items="props">
            <td>{{ props.item.nazev_osoby }}</td>
            <td>{{ props.item.telefon }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.pozice }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        headers: [
          { text: 'Jméno a příjmení', value: 'jmeno', sortable: false },
          { text: 'Telefon', value: 'telefon', sortable: false },
          { text: 'Email', value: 'email', sortable: false },
          { text: 'Pozice', value: 'pozice', sortable: false }
        ],
        counter: 0,
        loadingTable: false,
        search: "",
        items: []
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("obchody/nadrizeni/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  }
</script>
